import React, { useState } from "react";
import Header from "../Sections/Home/Header/Header";
import BlogPageDetail from "../Sections/BlogPage/BlogPageDetail";
import Footer from "../Footer/Footer";
import FreeApp from "../Sections/Download/FreeApp";
const BlogPage = () => {
  return (
    <>
      <Header></Header>
      <BlogPageDetail></BlogPageDetail>
      <FreeApp></FreeApp>
      <Footer></Footer>
    </>
  );
};
export default BlogPage;
